import {
  AiOutlineFundProjectionScreen,
  AiOutlineHome,
  AiOutlineUser,
} from "react-icons/ai";
import React, { useState } from "react";

import { CgFileDocument } from "react-icons/cg";
import Container from "react-bootstrap/Container";
import { HandymanOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { MdContactPage } from "react-icons/md";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useRef } from "react";

function NavBar() {
  const ref = useRef(null);
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleId = (id) => {
    var element = document.getElementById(id);
    console.log(id, element);
    // element.scrollIntoView();
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const createDownload = () => {
    const url =
      "https://drive.google.com/uc?export=download&id=1MrdIF9x3xdriQ54jcwmAIctjvafLfjXs";
    const a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="https://jubershaikh2307.github.io/">
          Juber Shaikh
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            handleId("home");
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav
            className="ml-auto"
            style={{ width: "100%" }}
            defaultActiveKey="#home"
          >
            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("home");
                  updateExpanded(false);
                }}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("about");
                  updateExpanded(false);
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("skill");
                  updateExpanded(false);
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> Skills
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("education");
                  updateExpanded(false);
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} />
                Timeline
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("project");
                  updateExpanded(false);
                }}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                onClick={() => {
                  handleId("contact");
                  updateExpanded(false);
                }}
              >
                <MdContactPage
                  style={{ marginBottom: "2px", color: "white" }}
                />
                Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} onClick={createDownload}>
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
